import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import moment from 'moment';
import 'moment/locale/de';

moment.locale('de');

createRoot(document.getElementById('root')!).render(<App />);
